export default "__VITE_ASSET__BiovYJL2__"